<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">

			<el-form-item label="UID">
				<el-input size="small" v-model="ruleForm.uid" disabled></el-input>
			</el-form-item>
			<el-form-item label="用户名">
				<el-input size="small" v-model="ruleForm.username" disabled></el-input>
			</el-form-item>
			
			<el-form-item label="提现金额">
				<el-input type="number" size="small" v-model="ruleForm.amount"></el-input>
			</el-form-item>
			
			<el-form-item label="提现方式">
				<el-input size="small" v-model="ruleForm.draw_name" disabled></el-input>
			</el-form-item>
				
			<el-form-item label="提现账号">
				<el-input size="small" v-model="ruleForm.account"></el-input>
			</el-form-item>
			
			<el-form-item label="操作" prop="status">
				<el-select v-model="ruleForm.status">
				      <el-option label="待处理" :value="0"></el-option>
				      <el-option label="已同意" :value="1"></el-option>
					  <el-option label="已拒绝" :value="2"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="备注信息" prop="remarks">
				<el-input size="small" v-model="ruleForm.remarks"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">确认操作</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
	    data() {
			return {
				rules: {
					status: [{required: true, message: '请选择操作类型', trigger: 'blur'}],
					remarks: [{required: true, message: '请输入备注信息', trigger: 'blur'}],
					
				}
	      };
	    },
	    methods: {
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '处理中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Recharge/actionDraw", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '操作成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: solid 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 80px;
	    height: 80px;
	    display: block;
	  }
</style>